import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      queryParams.append(key, params[key].toString());
    });
  }
  return `${baseUrl}?${queryParams.toString()}`;
}

// Get Notifications
function getNotifications(params: { skip: number; limit: number }) {
  const baseUrl = "notifications";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
}

// Get Unread Count
function getUnreadCount() {
  const baseUrl = "notifications/unread-count";

  try {
    return getApiInstance().get(baseUrl);
  } catch (error) {
    console.error("Error fetching unread count:", error);
    throw error;
  }
}

// Mark as Read
function markAsRead(params: { id: string }) {
  const baseUrl = `notifications/${params.id}`;

  try {
    return getApiInstance().put(baseUrl, { isRead: true });
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
}

// Mark All as Read
function markAllAsRead() {
  const baseUrl = "notifications/is-read-all";

  try {
    return getApiInstance().put(baseUrl, {});
  } catch (error) {
    console.error("Error marking all as read:", error);
    throw error;
  }
}

export { getNotifications, getUnreadCount, markAsRead, markAllAsRead };
